import { escapeHtmlAttr } from "./mailLineParts";

const IMG_STYLE = "display:block;margin:0 auto;border:0;outline:none;text-decoration:none;";

function mailPngIcon(src: string, alt: string, size: number): string {
  return `<img src="${escapeHtmlAttr(src)}" alt="${escapeHtmlAttr(alt)}" width="${size}" height="${size}" border="0" style="${IMG_STYLE}" />`;
}

function twemojiPng(code: string): string {
  return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/${code}.png`;
}

function brandFaviconPng(domain: string): string {
  return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${domain}&size=64`;
}

export const MAIL_GOOGLE_G_PNG =
  "https://www.gstatic.com/images/branding/googleg/1x/googleg_standard_color_48dp.png";

export const MAIL_GOOGLE_STARS_HTML =
  '<span style="color:#FBBC04;font-size:18px;letter-spacing:2px;line-height:20px;font-family:Arial,Helvetica,sans-serif;">&#9733;&#9733;&#9733;&#9733;&#9733;</span>';

export function mailGoogleGIconHtml(): string {
  return mailPngIcon(MAIL_GOOGLE_G_PNG, "Google", 32);
}

export function mailContactIconHtml(kind: string, label: string): string {
  switch (kind) {
    case "phone":
      return mailPngIcon(twemojiPng("260e"), label, 28);
    case "email":
      return mailPngIcon(twemojiPng("2709"), label, 28);
    case "website":
      return mailPngIcon(twemojiPng("1f310"), label, 28);
    case "facebook":
      return mailPngIcon(brandFaviconPng("facebook.com"), label, 28);
    case "instagram":
      return mailPngIcon(brandFaviconPng("instagram.com"), label, 28);
    case "linkedin":
      return mailPngIcon(brandFaviconPng("linkedin.com"), label, 28);
    case "youtube":
      return mailPngIcon(brandFaviconPng("youtube.com"), label, 28);
    case "whatsapp":
      return mailPngIcon(brandFaviconPng("whatsapp.com"), label, 28);
    default:
      return mailPngIcon(twemojiPng("1f310"), label, 28);
  }
}
